export const InputLengthFormatters = {
  nameMaxLength: 20,
  usernameMaxLength: 20,
  userBioMaxLength: 160,
  /** Maximum character length for report/appeal comment fields */
  reportMaxLength: 200,
  /** Maximum character length for content description */
  contentDescriptionMaxLength: 900,
  /**
   * Maximum character length for the Contact page's request content and
   * email textareas. Mirrors Flutter's `LengthLimitingTextInputFormatter(1000)`
   * in `lib/presentation/web/contact_screen.dart:357,396`.
   */
  contactRequestMaxLength: 1000,
  /**
   * Maximum character length for the Add-idea (roadmap) title field. Mirrors
   * Flutter's `LengthLimitingTextInputFormatter(100)` in
   * `lib/presentation/screens/roadmap/add_roadmap_item_screen.dart` (title field).
   */
  roadmapTitleMaxLength: 100,
  /**
   * Maximum character length for the Add-idea (roadmap) description field.
   * Mirrors Flutter's `LengthLimitingTextInputFormatter(300)` in
   * `lib/presentation/screens/roadmap/add_roadmap_item_screen.dart` (description field).
   */
  roadmapDescriptionMaxLength: 300,
  /**
   * Maximum character length for the add-feedback description field. Mirrors
   * Flutter's `LengthLimitingTextInputFormatter(200)` in
   * `lib/presentation/screens/feedback/in_app_feedback_screen.dart:354`.
   */
  feedbackDescriptionMaxLength: 200,
} as const;
